module.exports = __webpack_public_path__ + "static/media/1009764.97b57ea2.jpg";